import React from "react"
import { graphql } from "gatsby"

import { SEO } from "components"

import Hero from "./_Hero"
import ProductList from "./_ProductList"
import Footer from "./_Footer"

function ProductCategory({ data }) {
  const { contentfulProductCategory } = data
  const category = contentfulProductCategory

  return (
    <>
      <SEO
        title={category?.name}
        description={category?.seoDescription?.internal?.content}
        image={category?.image}
      />
      <main>
        <Hero {...category} />
        <ProductList {...category} />
        <Footer {...category} />
      </main>
    </>
  )
}

export const pageQuery = graphql`
  query ProductCategoryQuery($slug: String) {
    contentfulProductCategory(slug: { eq: $slug }) {
      slug
      name
      seoDescription {
        internal {
          content
        }
      }
      colorTheme
      slogan
      fillerText
      heading {
        raw
      }
      description {
        description
      }
      categoryList {
        links {
          ...LinkFragment
        }
      }
      subcategoryList {
        slug
        title
        slogan
        menuPhoto {
          ...AssetFragment
          gatsbyImageData(
            width: 180
            aspectRatio: 1
            resizingBehavior: PAD
            quality: 75
          )
        }
      }
      image {
        ...AssetFragment
        gatsbyImageData(
          width: 388
          aspectRatio: 1
          resizingBehavior: FILL
          placeholder: BLURRED
          quality: 75
        )
      }
      decorator {
        ...DecoratorFragment
      }
    }
  }
`

export default ProductCategory
